import styled from 'styled-components';

const StyledDiv = styled.div`
  position: relative;
  ${props => props.theme.mixins.boxSizing}
`;

export const StyledGrid = styled(StyledDiv).attrs(props => {
  const margins = props.noGutters
    ? 'margin-left: 0; margin-right: 0;'
    : props.theme.mixins.grid;

  return {
    margins,
  };
})`
  display: flex;
  flex-wrap: wrap;

  ${props => props.margins}
`;

export const StyledGridItem = styled(StyledDiv).attrs(props => {
  const { keys, up } = props.theme.breakpoints;
  const gutters = props.noGutters
    ? '' //'padding-left: 0; padding-right: 0;'
    : props.theme.mixins.gutters;

  const responsiveStyles = Object.keys(props)
    .filter(key => keys.includes(key))
    .reduce((prev, current) => {
      const width = `${(props[current] / props.gridSize) * 100}%`;
      const query = `${up(current)} {
        flex: 0 0 ${width};
        max-width: ${width};
      }`;

      return `${prev}${query}`;
    }, '');

  return {
    gutters,
    responsiveStyles,
  };
})`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  width: 100%;

  ${props => props.gutters}
  ${props => props.responsiveStyles}
`;
